'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Label = require('./Label');

var _Label2 = _interopRequireDefault(_Label);

var _InputError = require('./InputError');

var _InputError2 = _interopRequireDefault(_InputError);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FormGroup = function (_PureComponent) {
  _inherits(FormGroup, _PureComponent);

  function FormGroup() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, FormGroup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FormGroup.__proto__ || Object.getPrototypeOf(FormGroup)).call.apply(_ref, [this].concat(args))), _this), _this.getClassName = function () {
      var _this$props = _this.props,
          className = _this$props.className,
          errors = _this$props.errors;

      var baseClasses = 'FormGroup ' + className;
      return errors.length !== 0 ? baseClasses + ' has-error' : baseClasses;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(FormGroup, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          errors = _props.errors,
          text = _props.text,
          supplementaryText = _props.supplementaryText;

      return _react2.default.createElement(
        'div',
        { className: this.getClassName() },
        _react2.default.createElement(
          _Label2.default,
          { text: text, supplementaryText: supplementaryText },
          this.props.children,
          _react2.default.createElement(_InputError2.default, { errors: errors })
        )
      );
    }
  }]);

  return FormGroup;
}(_react.PureComponent);

FormGroup.propTypes = {
  text: _propTypes2.default.string.isRequired,
  supplementaryText: _propTypes2.default.string,
  className: _propTypes2.default.string.isRequired,
  errors: _propTypes2.default.array
};

FormGroup.defaultProps = {
  className: '',
  errors: []
};

exports.default = FormGroup;


//////////////////
// WEBPACK FOOTER
// ../frontend-component-library/build/Components/FormInputs/FormGroup.js
// module id = 96
// module chunks = 0